module.exports = __webpack_public_path__ + "img/yWVzq5fc9EZ31cK5lnC_Wi0aQ3Q.29c7454e.png";